export default __webpack_public_path__ + "static/media/banner.a17934d0.png";